import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { loadUserPolicies, loadUserPoliciesFailed, loadUserPoliciesSuccess } from "../actions/user-policies.action";
import { catchError, map, mergeMap } from "rxjs";
import { UserPoliciesService } from "src/app/services/user-policies/user-policies.service";

@Injectable()
export class UserPoliciesEffects {
	private actions$ = inject(Actions);
	private userPoliciesService = inject(UserPoliciesService);


	// Load the user policies from backend blob storage
	loadUserPolicie$ = createEffect(() => this.actions$.pipe(
		ofType(loadUserPolicies),
		mergeMap(() =>
			this.userPoliciesService.loadUserPolicies().pipe(
				map(resp => loadUserPoliciesSuccess({ userPolicies: resp.data })),
				catchError(async (error) => loadUserPoliciesFailed({ error: error })),
			)
		)
	));

}